module.exports = __webpack_public_path__ + "assets/integral-alt.32747e49.svg";